var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2016_18323",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2016_18323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.30039 11.0336L11.0671 7.26689L10.1171 6.31689L7.30039 9.13356L5.88372 7.71689L4.93372 8.66689L7.30039 11.0336ZM8.00039 14.6669C7.16706 14.6669 6.38661 14.5087 5.65906 14.1922C4.93106 13.8753 4.29772 13.4473 3.75906 12.9082C3.21995 12.3696 2.79195 11.7362 2.47506 11.0082C2.15861 10.2807 2.00039 9.50023 2.00039 8.66689C2.00039 7.83356 2.15861 7.05289 2.47506 6.32489C2.79195 5.59734 3.21995 4.96401 3.75906 4.42489C4.29772 3.88623 4.93106 3.45867 5.65906 3.14223C6.38661 2.82534 7.16706 2.66689 8.00039 2.66689C8.83372 2.66689 9.61439 2.82534 10.3424 3.14223C11.0699 3.45867 11.7033 3.88623 12.2424 4.42489C12.7811 4.96401 13.2088 5.59734 13.5257 6.32489C13.8422 7.05289 14.0004 7.83356 14.0004 8.66689C14.0004 9.50023 13.8422 10.2807 13.5257 11.0082C13.2088 11.7362 12.7811 12.3696 12.2424 12.9082C11.7033 13.4473 11.0699 13.8753 10.3424 14.1922C9.61439 14.5087 8.83372 14.6669 8.00039 14.6669ZM3.73372 1.56689L4.66706 2.50023L1.83372 5.33356L0.900391 4.40023L3.73372 1.56689ZM12.2671 1.56689L15.1004 4.40023L14.1671 5.33356L11.3337 2.50023L12.2671 1.56689ZM8.00039 13.3336C9.30039 13.3336 10.4031 12.8807 11.3084 11.9749C12.2142 11.0696 12.6671 9.96689 12.6671 8.66689C12.6671 7.36689 12.2142 6.26401 11.3084 5.35823C10.4031 4.45289 9.30039 4.00023 8.00039 4.00023C6.70039 4.00023 5.59772 4.45289 4.69239 5.35823C3.78661 6.26401 3.33372 7.36689 3.33372 8.66689C3.33372 9.96689 3.78661 11.0696 4.69239 11.9749C5.59772 12.8807 6.70039 13.3336 8.00039 13.3336Z",
    fill: "#343434"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.17be93b144a9a9fad09460b9c0f49a5f.svg";
export { ForwardRef as ReactComponent };